import React from "react";
import { usePageHistoryStore } from "../stores/usePageHistoryStore";

// Компонент пошуку логів історії сторінки
const HistorySearch = () => {
  // Отримуємо дані та дії зі стору
  const search = usePageHistoryStore((state) => state.filters.search);
  const setHistoryFilter = usePageHistoryStore((state) => state.setHistoryFilter);
  const fetchLogs = usePageHistoryStore((state) => state.fetchLogs);

  // Обробник зміни значення поля пошуку
  const handleOnChange = (e) => {
    setHistoryFilter({ search: e.target.value });
  };

  // Обробник натискання Enter для запуску пошуку
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchLogs();
    }
  };

  return (
    <div className="history-search">
      <h4 className="history-search__title">Пошук</h4>
      <div className="history-search__input-wrapper">
        <input
          type="text"
          placeholder="Введіть артикул (напр. TG-TA4125)"
          className="history-search__input"
          value={search}
          onChange={handleOnChange}
          onKeyDown={handleKeyDown}
        />

        <button
          className="history-search__button"
          onClick={fetchLogs}
          title="Шукати"
        >
          &#x1F50E;&#xFE0E;
        </button>
      </div>
    </div>
  );
};

export default HistorySearch;
